window.dataLayer = window.dataLayer || [];
$("body").on("click", ".questioner_answer_master  h3", function () {
  $(this).toggleClass("active");
  $(this).closest(".questioner_answer_master").find(".questions_answers").slideToggle();
});

$("body").on("click", ".questions_answers  h4", function () {
  $(this).toggleClass("active");
  $(this).closest(".questions_answers").find(".answers").slideToggle();
});

if (localStorage.getItem("age-confirm") === null) {
  $("body").addClass("age-popup-active");
  $("body").find(".age_popup_section").addClass("open-model");
}


$("body").on("click", ".slide-nav__button_close", function () {
  $(this).closest(".slide-nav__item").find(".child-nav__dropdown").slideToggle();
  $(this).find(".slide-nav__link").addClass("active");
  $(this).addClass($(this).attr("data-class"));
  $(this).addClass("slide-nav__button_open");
  $(this).removeClass("slide-nav__button_close");
});

$("body").on("click", ".slide-nav__button_open", function () {
  $(this).closest(".slide-nav__item").find(".child-nav__dropdown").slideToggle();
  $(this).find(".slide-nav__link").removeClass("active");
  $(this).removeClass($(this).attr("data-class"));
  $(this).removeClass("slide-nav__button_open");
  $(this).addClass("slide-nav__button_close");
});


$("body").on("click", ".chat_button", function (e) {
  e.preventDefault();
  window.HubSpotConversations.widget.open();
});


$("body").on("change", ".variant_input_check", function () {
  $(".error_message").hide();
  var labelText, qtyText, product_atc, product_qty, productPageInventory, price, qty, ele, productForm;
  labelText = $(this).closest(".variant-input").find("label");
  // if ($(labelText).text().indexOf("Azee") >= 0 || $(labelText).text().indexOf("Deyaa") >= 0) {
  //   $(".page-content.page-content--product").addClass("black-content");
  //   $(".product_meta_title.special_addition").show();
  //   $(".product_meta_title.normal_product").hide();
  //   $("#special_addition").show();
  // }
  // else {
  //   $(".page-content.page-content--product").removeClass("black-content");
  //   $(".product_meta_title.special_addition").hide();
  //   $(".product_meta_title.normal_product").show();
  //   $("#special_addition").hide();
  // }
  productForm = $(".product-form-block");
  $(this).closest(".variant-input-wrap").find(".variant-input").removeClass("active");
  $(".variant_input_check").removeClass("selected-variant");
  if ($(this).hasClass("disabled")) {
    $(this).prop('checked', false);
    $(this).closest(".flavor_product_detail").find(".control").addClass("op-0-5");
    $(this).closest(".flavor_product_detail").find(".control").find("input").val(0);
  }
  else {
    $(this).closest(".variant-input").addClass("active");
    $(this).addClass("selected-variant");
    $(this).closest(".flavor_product_detail").find(".control").removeClass("op-0-5");
  }

  $(this).closest(".variant-wrapper").find(".variant__label-info").find("span").text($(labelText).text());
  // if ($(labelText).text() === 'Deyaa' || $(labelText).text() === 'Azee') {
  //   $(".color_name").text($(labelText).text().toUpperCase() + ' limited edition');
  // }
  // else {
    $(".color_name").text($(labelText).text());
  // }
  $(".selected-color").css("background-color", $(labelText).text());

  qtyText = $(this).closest(".grid-item__content").find(".product-inventory");
  product_atc = $(this).closest(".product_variants_collections").find(".product_atc");
  product_qty = $(this).closest(".product_variants_collections").find(".form-qty");

  productPageInventory = $(this).closest("div[data-product-blocks]").find(".product-inventory");

  if ($(this).hasClass("disabled")) {
    $(qtyText).removeClass("in-stock");
    $(qtyText).addClass("out-stock");
    if (window.location.href.indexOf("/kk") > -1) {
      $(qtyText).find("span").text("غير متوفر");
    }
    else{
      $(qtyText).find("span").text("OUT OF STOCK");
    }

    $(productPageInventory).removeClass("in-stock");
    $(productPageInventory).addClass("out-stock");
    if (window.location.href.indexOf("/kk") > -1) {
      $(productPageInventory).find("span").text("غير متوفر");
    }
    else{
      $(productPageInventory).find("span").text("OUT OF STOCK");
    }


    $(product_atc).addClass("bg-soldOut wd-100");
    $(product_qty).hide();
    if (window.location.href.indexOf("/kk") > -1) {
      $(product_atc).find("span").text("Soldout");
    }
    else{
      $(product_atc).find("span").text("تم البيع");
    }

    $(productForm).find(".product-grid-form").hide();
    $(productForm).find("form").css("width", "100%");
  }
  else {

    $(qtyText).addClass("in-stock");
    $(qtyText).removeClass("out-stock");
    if (window.location.href.indexOf("/kk") > -1) {
      $(qtyText).find("span").text("ҚОЙМАДА");
    }
    else{
      $(qtyText).find("span").text("В НАЛИЧИИ");
    }

    $(productPageInventory).addClass("in-stock");
    $(productPageInventory).removeClass("out-stock");
    if (window.location.href.indexOf("/kk") > -1) {
      $(productPageInventory).find("span").text("ҚОЙМАДА");
    }
    else{
      $(productPageInventory).find("span").text("В НАЛИЧИИ");
    }

    $(product_atc).removeClass("bg-soldOut wd-100");
    $(product_qty).show();
    if (window.location.href.indexOf("/kk") > -1) {
      $(product_atc).find("span").text("СЕБЕТКЕ ҚОСУ");
    }
    else{
      $(product_atc).find("span").text("Добавить в корзину");
    }

    $(productForm).find(".product-grid-form").show();
    $(productForm).find("form").css("width", "auto");
  }

  price = $(this).closest(".variant-input").attr("data-price");
  qty = parseInt($(this).closest(".product_variants_collections").find(".qty").val());
  if (qty) {
    qty = qty;
  }
  else {
    qty = parseInt($(this).closest("div[data-product-blocks]").find(".qty").val());
  }

  ele = $(this).closest(".product_variants_collections").closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");
  if (ele.length > 0) {

    ele = ele;
  }
  else {
    ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");
  }
  price = parseInt(price.replace(/,/g, ''), 10);
  if (qty > 0) {
    priceDynamic(price, qty, ele);
  }
  if ($(this).hasClass("disabled")) {
  }
  else {
    colorSwatchRecommendation(this);
  }

  var variantLength = $(".product-grid__content").find(".variant-input");
  $(".rte.multiple_description").hide();

  for (var i = 0; i < variantLength.length; i++) {
    if ($(variantLength[i]).hasClass("active")) {
      var children = i + 1;
      $(".rte.multiple_description:nth-child(" + children + ")").show();
    }
  }


});


$("body").on("click", ".add-to-cart-grid", function () {

  var productId = $(this).closest(".product_variants_collections").find(".selected-variant").closest(".variant-input").attr("data-id");
  if (productId) {
    productId = productId;
  }
  else {
    productId = $(this).closest(".product_variants_collections").find(".height-67").attr("data-id");
  }
  var qty = $(this).closest(".product-grid-form").find(".input-text").val();
  if (window.location.href.indexOf("/kk") > -1) {
    $(this).find("span").text("СЕБЕТКЕ ҚОСУ");
  }
  else{
    $(this).find("span").text("ДОБАВИТЬ В КОРЗИНУ");
  }
  var parentDiv = $(this).closest(".grid-item.grid-product");
  var productPrice = $(parentDiv).find(".grid-product__price--current").find(".visually-hidden").text();
  var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
  var collectionName = $(parentDiv).attr("product-collection-name");
  var productTitle = $(parentDiv).find(".grid-product__title").text();
  var sku = $(".product_variant_picker").find(".variant-input.active").attr("data-sku");
  var optionName = $(parentDiv).find(".variant__label").text();
  var dataPresale = $(this).data("presale");
  console.log(dataPresale);
  addToCart(dataPresale, productId, qty, productTitle, productPrice, variant, collectionName, sku, optionName, grid_button = this);

});
$("body").on("click", ".read_more_less", function () {
  $(this).closest(".collection_description").find("p").toggleClass("open");
  $(this).toggleClass("open");
  if ($(this).find("span").text() == "Show More") {
    $(this).find("span").text("Show Less");
  } else {
    $(this).find("span").text("Show More");
  }
});


$("body").on("click", ".minus-plus", function () {
  $(this).closest(".control").find(".button-minus").removeClass("op-0-5");
  var productQty, ele, price;

  productQty = parseInt($(this).closest(".control").find(".input-text").val());

  if (jQuery.isNumeric(productQty)) {
    if ($(this).hasClass("button-minus")) {
      productQty = parseInt(productQty - 1);
      if (productQty < 0 || productQty === 0) {
        $(this).addClass("op-0-5");
        $(this).closest(".control").find(".input-text").val(0);
        $(this).closest(".product-grid-form").find(".product_atc").addClass("disabled-btn");
        $(".add-to-cart-product").addClass("disabled-btn");


        ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

        if (ele.length > 0) {

          ele = ele;
        }
        else {

          ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");

        }
        priceDynamic(0.00, 0, ele);

      }
      else {
        $(this).removeClass("op-0-5");
        $(".add-to-cart-product").removeClass("disabled-btn");
        $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
        $(this).closest(".control").find(".input-text").val(productQty);

        productQty = parseInt($(this).closest(".control").find(".input-text").val());
        ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

        if (ele.length > 0) {

          ele = ele;
        }
        else {

          ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");

        }
        price = $(this).closest(".product_variants_collections").find(".variant-input.active").attr("data-price");
        if (price) {
          price = parseInt(price.replace(/,/g, ''), 10);
        }
        else {
          price = $(this).closest(".control").attr("data-price");
          price = parseInt(price.replace(/,/g, ''), 10);
        }
        // price = parseInt(price.replace(/,/g, ''), 10);
        priceDynamic(price, productQty, ele);
      }

    }
    else {
      $(".add-to-cart").removeClass("disabled-btn");
      $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
      $(this).closest(".control").find(".input-text").val(parseInt(productQty + 1));

      productQty = parseInt($(this).closest(".control").find(".input-text").val());
      ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

      if (ele.length > 0) {
        ele = ele;
      }
      else {
        ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");

      }

      price = $(this).closest(".product_variants_collections").find(".variant-input.active").attr("data-price");
      if(price){
        price = parseInt(price.replace(/,/g, ''), 10);
        // price = price;
      }
      else{
        price = $(this).closest(".control").attr("data-price");
        price = parseInt(price.replace(/,/g, ''), 10);
      }

      // if (price) {
      //   price = price;
      // }
      // else {
      //   price = parseInt($(this).closest(".control").attr("data-price"));
      //   price = parseInt(price.replace(/,/g, ''), 10);
      // }
      priceDynamic(price, productQty, ele);

    }
  }

});


$("body").on("change", ".input-text", function () {
  var productQty, ele, price;
  if ($(this).val()) {
    productQty = parseInt($(this).val());
    if (productQty < 0) {
      $(this).val(0);
      productQty = 0;
    }
    ele = $(this).closest(".grid-item__content").find(".grid-product__price--current").find("span[aria-hidden='true']");

    if (ele.length > 0) {

      ele = ele;
    }
    else {
      ele = $(this).closest("div[data-product-blocks]").find(".product__price").find("span[aria-hidden='true']");
    }

    price = parseFloat($(this).closest(".product_variants_collections").find(".variant-input.active").attr("data-price"));

    if (price) {
      price = price;
    }
    else {
      price = parseFloat($(this).closest(".control").attr("data-price"));
    }

    if (productQty === 0) {

      $(this).closest(".product-grid-form").find(".product_atc").addClass("disabled-btn");
    }
    else {

      $(this).closest(".product-grid-form").find(".product_atc").removeClass("disabled-btn");
    }
    priceDynamic(price, productQty, ele);
  }
});



function addToCart(dataPresale, productId, qty, productTitle, price, variant, collection, sku, optionName, grid_button, oldId, OldProductName) {
  window.dataLayer.push({
    'event': 'add_to_cart',
    'ecommerce': {
      'items': [{
        'item_name': productTitle, // Name or ID is required. 
        'item_id': productId,
        'price': price,
        'item_brand': 'GLO',
        'item_category': collection,
        'item_category_2': '',
        'item_category_3': '',
        'item_category_4': '',
        'item_variant': variant,
        'item_list_name': '',
        'item_list_id': '',
        'index': 1,
        'quantity': qty
      }]
    }
  });
  window.dataLayer.push({
    'event': 'addToCart',
    'ecommerce':
    {
      'currencyCode': 'KZT',
      'add': {
        'products': [{
          'name': productTitle,
          'id': sku,
          'price': price,
          'brand': 'GLO',
          'strength': variant,
          'quantity': qty,
          'format': optionName,
          'dimension': variant,
        }
        ]
      }
    }
  });
var properties = {};

// presale logic
if (dataPresale) {
  properties["promo_name"] = "presale";
}

// trade-in logic
if (oldId !== '') {
  properties["Trade In Device Id"] = oldId;
  properties["Trade In Device Name"] = OldProductName;
}

// final payload
var dataArray = {
  id: productId,
  quantity: qty
};

// only attach properties if any exist
if (Object.keys(properties).length > 0) {
  dataArray.properties = properties;
}
  $.ajax({
    type: "POST",
    url: theme.routes.cartAdd,
    dataType: "json",
    data: dataArray,
    success: function (data) {
      openCart();
    },
    error: function (data) {
      $(grid_button).closest(".product_variants_collections").find(".error_message").fadeIn();
      $(".error_message_product").fadeIn();
      $(grid_button).closest(".product_variants_collections").find(".error_message").text(data.responseJSON.description);
      $(".error_message_product").text(data.responseJSON.description);
      if (window.location.href.indexOf("/kk") > -1) {
        $(grid_button).find("span").text("СЕБЕТКЕ ҚОСУ");
        $(".add-to-cart_custom").find("span").text("СЕБЕТКЕ ҚОСУ");
      }
      else{
        $(grid_button).find("span").text("ДОБАВИТЬ В КОРЗИНУ");
        $(".add-to-cart_custom").find("span").text("ДОБАВИТЬ В КОРЗИНУ");
      }
      setTimeout(function () {
        $(".error_message_product").fadeOut();
        $(grid_button).closest(".product_variants_collections").find(".error_message").fadeOut();
      }, 4000);
    }
  });
}

$(document).ready(function () {
  var labelText = $(".variant-input.active").find("label");
  // if ($(labelText).text().indexOf("Azee") >= 0 || $(labelText).text().indexOf("Deyaa") >= 0) {
  //   $(".page-content.page-content--product").addClass("black-content");
  //   $(".product_meta_title.special_addition").show();
  //   $(".product_meta_title.normal_product").hide();
  //   $("#special_addition").show();
  // }
  // else {
  //   $(".page-content.page-content--product").removeClass("black-content");
  //   $(".product_meta_title.special_addition").hide();
  //   $(".product_meta_title.normal_product").show();
  //   $("#special_addition").hide();
  // }

  setInterval(function () {
    var activeState = $(".product-grid__content").find(".variant-input.active").find("label");
    // if ($(activeState).text().includes("Deyaa") || $(activeState).text().includes("Azee")) {

    //   $(".color_name").text($(activeState).text().toUpperCase() + ' limited edition');
    // }
    // else {
      $(".color_name").text($(activeState).text());
    // }
    if ($(activeState).attr("data-variant-color-image")) {
      var imgUrl = $(activeState).attr("data-variant-color-image");
      $(".selected-color").css("background-image", "url(" + imgUrl + ")");
      $(".selected-color").css("background-color", "");
    }
    else {
      $(".selected-color").css("background-image", "url('')");
      $(".selected-color").css("background-color", $(activeState).attr('data-color-fallBack'));
    }
  }, 800);

  // $(".site-nav__link_account").hover(function(){
  //   $(".overlay").addClass("overlay-open");
  //   $(".account_child_links").addClass("open-account");
  //   }, function(){
  //     if($(".account_child_links").hasClass("open-account")){

  //     }
  //     else{
  //       $(".overlay").removeClass("overlay-open");
  //       $(".account_child_links").removeClass("open-account");
  //     }
  // });
});

function priceDynamic(price, qty, ele) {

  $(ele).text("₸ " + (price * qty).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
}


function colorSwatchRecommendation(e) {

  colorImages = $(e).closest(".variant-input").find("label[data-variant-id]");
  if (colorImages.length) {
    setActiveColorImage(colorImages);
  }
}

function setActiveColorImage(swatch) {
  var id = $(swatch).attr("data-variant-id");
  var image = $(swatch).attr("data-variant-image");
  if (image) {

    $(swatch).closest(".grid-item__content").find(".grid-product__color-image").removeClass("is-active");
    // Set active image and swatch
    var imageEl = $(swatch).closest(".grid-item__content").find('.grid-product__color-image--' + id);
    $(imageEl).css("background-image", "url(" + image + ")");
    //   imageEl.style.backgroundImage = 'url(' + image + ')';
    $(imageEl).addClass('is-active');

  }
  // Update product grid item href with variant URL
  var variantUrl = $(swatch).attr("data-url");
  var gridItem = $(swatch).closest(".grid-item__content").find('.grid-item__link');

  $(gridItem).attr('href', variantUrl);
}


$("body").on("click", ".add-to-cart_bundle", function (e) {
  e.preventDefault();
  var qty = $(this).closest(".product-form-block").find(".js-qty__num").val();
  var currentVariant = $(".product_variant_picker").find(".variant-input.active");
  
  // if((typeof productId === "undefined")){
  //   productId = $(".product-single__variants").val();
  // }

  if (window.location.href.indexOf("/kk") > -1) {
    $(this).find("span[data-default-text]").text("Добавление...");
  }
  else{
    $(this).find("span[data-default-text]").text("Добавление...");
  }

  var productId = $(currentVariant).find(".bundle-variants");
  var productqty = $(currentVariant).find(".bundle-variants").attr("data-qty");
  productId = $(productId).attr("data-id");

  var array = productId.split(',');
  var qtyArray = productqty.split(',');


  var items = new Array();
  for (var i = 0; i < array.length; i++) {

    items.push({
      id: array[i],
      quantity: qtyArray[i],
      properties: {
        "_customBundle": '_customBundle'
      }
    })
  }

  var data = {
    items
  }

  if (window.location.href.indexOf("/kk") > -1) {
    $(this).find("span").text("Қосу...");
  }
  else{
    $(this).find("span").text("Добавление...");
  }
  $.ajax({
    type: "POST",
    url: theme.routes.cartAdd,
    dataType: "json",
    data: data,
    success: function (data) {
      openCart();
    },
    error: function (data) {
      $(".error_message").show();
      $(".error_message").text(data.responseJSON.description);
      if (window.location.href.indexOf("/kk") > -1) {
        $(".add-to-cart_bundle").find("span").text("СЕБЕТКЕ ҚОСУ");
      }
      else{
        $(".add-to-cart_bundle").find("span").text("Добавить в корзину");
      }
      // setTimeout(function () {
      //   $(".error_message").hide();
      // }, 3000);
    }
  });
});



$("body").on("click", ".add-to-cart-flavor", function () {
  var totalVal = 0;
  var itemsData = [];
  var inputs = $('.flavors_qty').find(".input-text");
  for (var i = 0; i < inputs.length; i++) {
    totalVal = parseInt($(inputs[i]).val()) + parseInt(totalVal);
    var productId = $(inputs[i]).closest(".flavor_product_detail").find(".flavors_variants").find(".variant-input.active").attr("data-id");
    if (productId) {
      itemsData.push({
        id: productId,
        quantity: parseInt($(inputs[i]).val()),
        properties: {
          "_customBundle": '_customBundle'
        }
      });
    }
  }
  if (totalVal > 0) {
    if (totalVal % 5 === 0) {

      $(".bundle_error_master").hide();
      if (window.location.href.indexOf("/kk") > -1) {
        $(this).find("span").text("Қосу...");
      }
      else{
        $(this).find("span").text("Добавление...");
      }
      bundleATC(itemsData);
    }
    else {
      var nextBundle = round(totalVal);
      var nextBundleRemaing = round(totalVal) - totalVal;
      var nextBundleCount = nextBundle / 5;

      $(".bundle_error_master").find("p").text("Select " + nextBundleRemaing + " additional flavors to complete your " + nextBundleCount);
      if (nextBundleCount === 1) {

        $(".bundle_error_master").find("p").append("<span>st</span> bundle");
      }
      else if (nextBundleCount === 2) {

        $(".bundle_error_master").find("p").append("<span>nd</span> bundle");
      }
      else if (nextBundleCount === 3) {

        $(".bundle_error_master").find("p").append("<span>rd</span> bundle");
      }
      else {

        $(".bundle_error_master").find("p").append("<span>th</span> bundle");
      }
      $(".bundle_error_master").show();
    }
  }
});

function round(x) {
  return Math.ceil(x / 5) * 5;
}

function bundleATC(items) {
  var data = {
    items
  };

  //   return;
  $.ajax({
    type: "POST",
    url: theme.routes.cartAdd,
    dataType: "json",
    data: data,
    success: function (data) {
      openCart();
    }
  });
}

$(window).on('load resize orientationchange', function () {
  $('.index-collcetion-content .new-grid').each(function () {
    var $carousel = $(this);
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: false,
          arrows: true,
          speed: 300,
          slidesToShow: 4,
          centerMode: false,
          centerPadding: '0',
          infinite: true,
          responsive: [
            {
              breakpoint: 1400,
              settings:{
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 1200,
              settings:{
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 1050,
              settings:{
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                speed: 300,
                slidesToShow: 2
              }
            },
          ]
        });
      }
  });
  $('.product-recommendations .new-grid').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    // if ($(window).width() > 768) {
    //   if ($carousel.hasClass('slick-initialized')) {
    //     $carousel.slick('unslick');
    //   }
    // }
    // else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: false,
          arrows: true,
          speed: 300,
          slidesToShow: 5,
          centerMode: false,
          centerPadding: '0',
          infinite: true,
          responsive: [
            {
              breakpoint: 1400,
              settings:{
                slidesToShow: 5,
              }
            },
            {
              breakpoint: 1200,
              settings:{
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 1050,
              settings:{
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1
              }
            },
          ]
        });
      }
    // }
  });
  /*$('.image_text_v3 .image_text_v2--inner').each(function () {
    var $carousel = $(this);
    if ($(window).width() > 768) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: true,
          arrows: false,
          speed: 300,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px',
        });
      }
    }
  });
  */

  $('.steps_slider').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          dots: true,
          arrows: false,
          speed: 1500,
          slidesToShow: 1,
          fade: true,
          lazyLoad: 'progressive',
          autoplay:true
        });
      }
  });
  $('.dh_bottom_features').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 768) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      $carousel.slick({
          dots: true,
          arrows: true,
          speed: 300,
          slidesToShow: 2,
          centerMode: false,
          centerPadding: '30px',
          prevArrow: '<button class="dh_bottom_prevArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 6.26248e-07 24.8366 1.39876e-06 16C2.17128e-06 7.16344 7.16345 -2.17128e-06 16 -1.39876e-06C24.8366 -6.26248e-07 32 7.16344 32 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.798 23.4186C19.5287 23.6879 19.092 23.6879 18.8227 23.4186L12.202 16.7979C12.0727 16.6686 12 16.4932 12 16.3103C12 16.1274 12.0727 15.9519 12.202 15.8226L18.8227 9.20191C19.092 8.93259 19.5287 8.93259 19.798 9.20191C20.0673 9.47124 20.0673 9.90791 19.798 10.1772L13.665 16.3103L19.798 22.4433C20.0673 22.7126 20.0673 23.1493 19.798 23.4186Z" fill="#2A2A2A"/></svg></button>',
          nextArrow: '<button class="dh_bottom_nextArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.202 8.58139C12.4713 8.31206 12.908 8.31206 13.1773 8.58139L19.798 15.2021C19.9273 15.3314 20 15.5068 20 15.6897C20 15.8726 19.9273 16.0481 19.798 16.1774L13.1773 22.7981C12.908 23.0674 12.4713 23.0674 12.202 22.7981C11.9327 22.5288 11.9327 22.0921 12.202 21.8228L18.335 15.6897L12.202 9.55671C11.9327 9.28738 11.9327 8.85072 12.202 8.58139Z" fill="#2A2A2A"/></svg></button>'
        });
    }
  });

  // ELIE ADD
  $('.discover-apex-features__list').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 768) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      $carousel.slick({
          dots: true,
          arrows: true,
          speed: 300,
          slidesToShow: 2,
          centerMode: false,
          centerPadding: '30px',
          prevArrow: '<button class="dh_bottom_prevArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 6.26248e-07 24.8366 1.39876e-06 16C2.17128e-06 7.16344 7.16345 -2.17128e-06 16 -1.39876e-06C24.8366 -6.26248e-07 32 7.16344 32 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.798 23.4186C19.5287 23.6879 19.092 23.6879 18.8227 23.4186L12.202 16.7979C12.0727 16.6686 12 16.4932 12 16.3103C12 16.1274 12.0727 15.9519 12.202 15.8226L18.8227 9.20191C19.092 8.93259 19.5287 8.93259 19.798 9.20191C20.0673 9.47124 20.0673 9.90791 19.798 10.1772L13.665 16.3103L19.798 22.4433C20.0673 22.7126 20.0673 23.1493 19.798 23.4186Z" fill="#2A2A2A"/></svg></button>',
          nextArrow: '<button class="dh_bottom_nextArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.202 8.58139C12.4713 8.31206 12.908 8.31206 13.1773 8.58139L19.798 15.2021C19.9273 15.3314 20 15.5068 20 15.6897C20 15.8726 19.9273 16.0481 19.798 16.1774L13.1773 22.7981C12.908 23.0674 12.4713 23.0674 12.202 22.7981C11.9327 22.5288 11.9327 22.0921 12.202 21.8228L18.335 15.6897L12.202 9.55671C11.9327 9.28738 11.9327 8.85072 12.202 8.58139Z" fill="#2A2A2A"/></svg></button>'
        });
    }
  });

  $('.pd_table_details').each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 971) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else {
      $carousel.slick({
          dots: false,
          arrows: true,
          speed: 300,
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '30px',
          prevArrow: '<button class="compare_prevArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 6.26248e-07 24.8366 1.39876e-06 16C2.17128e-06 7.16344 7.16345 -2.17128e-06 16 -1.39876e-06C24.8366 -6.26248e-07 32 7.16344 32 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.798 23.4186C19.5287 23.6879 19.092 23.6879 18.8227 23.4186L12.202 16.7979C12.0727 16.6686 12 16.4932 12 16.3103C12 16.1274 12.0727 15.9519 12.202 15.8226L18.8227 9.20191C19.092 8.93259 19.5287 8.93259 19.798 9.20191C20.0673 9.47124 20.0673 9.90791 19.798 10.1772L13.665 16.3103L19.798 22.4433C20.0673 22.7126 20.0673 23.1493 19.798 23.4186Z" fill="#2A2A2A"/></svg></button>',
          nextArrow: '<button class="compare_nextArrow"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#F6F6F6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.202 8.58139C12.4713 8.31206 12.908 8.31206 13.1773 8.58139L19.798 15.2021C19.9273 15.3314 20 15.5068 20 15.6897C20 15.8726 19.9273 16.0481 19.798 16.1774L13.1773 22.7981C12.908 23.0674 12.4713 23.0674 12.202 22.7981C11.9327 22.5288 11.9327 22.0921 12.202 21.8228L18.335 15.6897L12.202 9.55671C11.9327 9.28738 11.9327 8.85072 12.202 8.58139Z" fill="#2A2A2A"/></svg></button>'
        });
    }
  });
});

$("body").on("click", ".checkout_discount_button", function (e) {
  e.preventDefault();
  var disccount = $("input[name='dicount']").val();

  window.location.href = '/checkout?discount=' + disccount;
});

$("body").on("click", ".cart__continue", function (e) {
  e.preventDefault();
  window.location.href = document.referrer;
});

$("body").on("click", ".eye-close-open", function (e) {
  $(this).closest(".password_field").find(".eye-open").toggleClass("hide");
  $(this).closest(".password_field").find(".eye-close").toggleClass("hide");
  if ($(this).closest(".password_field").find(".input-full").attr("type") === 'password') {
    $(this).closest(".password_field").find(".input-full").attr("type", "text");
  }
  else {
    $(this).closest(".password_field").find(".input-full").attr("type", "password");
  }
});

$("body").on("click", ".address-edit", function () {
  var id = $(this).attr("data-form-id");
  var defaultCityVal = $("#EditAddress_"+id).find(".default-address-city").data("title");
  $("#AddressCity_"+id).val(defaultCityVal);
  $("#EditAddress_" + id).toggleClass("hide");
});

$("body").on("click", ".add-to-cart_custom", function (e) {
  e.preventDefault();
  var qty = $(this).closest("div[data-product-blocks]").find(".js-qty__num").val();
  var productId = $(".product_variant_picker").find(".variant-input.active").attr("data-id");
  
  if((typeof productId === "undefined")){
    productId = $(".product-single__variants").val();
  }
  var sku = $(".product_variant_picker").find(".variant-input.active").attr("data-sku");
  $(this).find("span[data-default-text]").text("Добавление...");
  var parentDiv = $(this).closest(".product-grid__content");
  var productPrice = $(parentDiv).find(".product__price").find(".visually-hidden").text();
  var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
  
  var collectionName = $(parentDiv).closest(".product-section").attr("data-collection");
  var productTitle = $(parentDiv).closest(".product-section").attr('data-product-title');
  var optionName = $(parentDiv).find(".variant__label").text();
  var dataPresale = $(this).data("presale");
  console.log(dataPresale);
  addToCart(dataPresale, productId, qty, productTitle, productPrice, variant, collectionName, sku, optionName);
});

$("body").on("click", ".custom_js-qty__adjust", function () {
  var inputVal = parseInt($(this).closest(".cart_update_button_master").find("input").val());
  var productId = $(this).closest(".cart_update_button_master").find("input").attr("data-id");
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var productCollection = $(parentDiv).attr("data-collection");
  var price = $(parentDiv).attr("data-price");
  var collection = $(parentDiv).attr("data-collection");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  if ($(this).hasClass("js-qty__adjust--minus")) {
    inputVal = parseInt(inputVal - 1);

    if (inputVal < 0) {
      inputVal = 0;

    }
    else {
      inputVal = inputVal;
    }
    window.dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [
            {
              'name': productTitle,
              'id': sku,
              'price': price,
              'brand': 'GLO',
              'strength': variant,
              'quantity': inputVal,
              'format': 'Can',
              'dimension': variant,
            }
          ]
        }
      }
    });
    window.dataLayer.push({
      'event': 'remove_from_cart',
      'ecommerce': {
        'items': [
            {
            'item_name': productTitle, // Name or ID is required.
            'item_id': productId,
            'price': price,
            'item_brand': 'GLO',
            'item_category': productCollection,
            'item_category_2' : '',
            'item_category_3' : '',
            'item_category_4' : '',
            'item_variant': variant,
            'item_list_name': '',
            'item_list_id': '',
            'index': '',
            'quantity': inputVal
          }
        ]
      }
    });
  }
  else {
    inputVal = inputVal + 1;
  }
  $(this).closest(".cart_update_button_master").find("input").val(inputVal);
  if (inputVal == '0') {
    window.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [{
          'item_name': productTitle, // Name or ID is required. 
          'item_id': productId,
          'price': price,
          'item_brand': 'GLO',
          'item_category': collection,
          'item_category_2': '',
          'item_category_3': '',
          'item_category_4': '',
          'item_variant': variant,
          'item_list_name': '',
          'item_list_id': '',
          'index': 1,
          'quantity': inputVal
        }]
      }
    });
  }
  updateCart(productId, inputVal);
});

$("body").on("change", ".custom_js-qty__num", function () {
  var productId = $(this).attr("data-id");
  var qty = parseInt($(this).val());
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var price = $(parentDiv).attr("data-price");
  var collection = $(parentDiv).attr("data-collection");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  if (qty == '0') {
    window.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [{
          'item_name': productTitle, // Name or ID is required. 
          'item_id': productId,
          'price': price,
          'item_brand': 'GLO',
          'item_category': collection,
          'item_category_2': '',
          'item_category_3': '',
          'item_category_4': '',
          'item_variant': variant,
          'item_list_name': '',
          'item_list_id': '',
          'index': 1,
          'quantity': qty
        }]
      }
    });
  }
    window.dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [
            {
              'name': productTitle,
              'id': sku,
              'price': price,
              'brand': 'GLO',
              'strength': variant,
              'quantity': inputVal,
              'format': 'Can',
              'dimension': variant,
            }
          ]
        }
      }
    });
    window.dataLayer.push({
      'event': 'remove_from_cart',
      'ecommerce': {
        'items': [
            {
            'item_name': productTitle, // Name or ID is required.
            'item_id': productId,
            'price': price,
            'item_brand': 'GLO',
            'item_category': collection,
            'item_category_2' : '',
            'item_category_3' : '',
            'item_category_4' : '',
            'item_variant': variant,
            'item_list_name': '',
            'item_list_id': '',
            'index': '',
            'quantity': qty
          }
        ]
      }
    });
  updateCart(productId, qty);
});

function updateCart(productId, qty) {
  $.ajax({
    type: 'POST',
    url: theme.routes.cartChange,
    data: { quantity: qty, id: productId },
    dataType: 'json',
    success: function (cart) {
      openCart();
    }
  });
}

function openCart() {
  var cartUrl = ''
  if(window.location.href.indexOf("/kk") > -1) {
    cartUrl = theme.routes.cartPage+'?view=drawer'
  }
  else{
    cartUrl = theme.routes.cartPage+'?view=drawer'
  }
  $.ajax({
    type: 'GET',
    url: cartUrl,
    async: false,
    success: function (cart) {
      $(".trade_in_popup").removeClass("open-model");
      $(".drawer__cart").html('');
      $(".drawer__cart").html(cart);
      $(".overlay").addClass("overlay-open");
      $("body").addClass("drawer-open");
      $("#myModal").addClass("view-model");
      $(".overlay").removeClass("overlay-opens");
      $("body").removeClass("age-popup-active");
      $(".trade-in-cta").removeClass("trade-in-active");
      $(".trade_in_devices").removeClass("view-trade_in_devices");
      var cartCount = parseInt($("#myModal").find(".cart_count").attr("data-id"));
      var cartPrice = $("#myModal").find(".total_price").find("span[aria-hidden='true']").text();
      if (cartCount > 0) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger").find(".site-nav__icon-label.small--hide").text(cartPrice);
      }
      else {
        $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
        $("#HeaderCartTrigger").find(".site-nav__icon-label.small--hide").text("₸ 0.00");
      }
      $(".cart-link__bubble-num").text(cartCount);
      if (window.location.href.indexOf("/kk") > -1) {
        $(".add-to-cart").find("span[data-default-text]").text("СЕБЕТКЕ ҚОСУ");
        $(".add-to-cart-grid").find("span").text("СЕБЕТКЕ ҚОСУ");
        $(".add-to-cart-flavor").find("span").text("СЕБЕТКЕ ҚОСУ");
        $(".add-to-cart-bundle").find("span").text("СЕБЕТКЕ ҚОСУ");
      }
      else{
        $(".add-to-cart").find("span[data-default-text]").text("Добавить в корзину");
        $(".add-to-cart-grid").find("span").text("Добавить в корзину");
        $(".add-to-cart-flavor").find("span").text("Добавить в корзину");
        $(".add-to-cart-bundle").find("span").text("Добавить в корзину");
      }
    }
  });
}
var container = $(".modal-content");
$(document).click(function () {
  if (!container.is(event.target) && !container.has(event.target).length) {
    $("#myModal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$(document).on('keydown', function (e) {
  if (e.keyCode === 27) { // ESC
    $("#myModal").removeClass("view-model");
    $(".overlay").removeClass("overlay-open");
    $("body").removeClass("drawer-open");
  }
});

$("body").on("click", ".close_model, .basket_button", function () {
  $("#myModal").removeClass("view-model");
  $(".overlay").removeClass("overlay-open");
  $("body").removeClass("drawer-open");
});

$('body').on("click", ".recyle_epod_input", function () {
  var selected_value = $("input[name='recyle_epod']:checked").val();

  if (selected_value === 'Yes') {
    $(".cart_note").val("Recycle");
  }
  else {
    $(".cart_note").val("");
  }
});


window.onload = setTimeout(function () {
  $(".grid__item").removeClass("op-0");
}, 2000);

var addressId = '';
$("body").on("click", ".address_delete_custom", function () {
  addressId = $(this).attr("data-id");
  $(".overlay").addClass("overlay-opens");
  $("body").addClass("drawer-opens");
  $(".address_remove_popup").addClass("view-address-model");
});

$("body").on("click", ".address_remove_btn_1", function () {
  Shopify.postLink('/account/addresses/' + addressId, { parameters: { _method: 'delete' } });
});
$("body").on("click", ".address_remove_btn_2, .close_address", function () {
  $(".overlay").removeClass("overlay-opens");
  $("body").removeClass("drawer-opens");
  $(".address_remove_popup").removeClass("view-address-model");
  $(".warranty_from_error").removeClass("view-warranty_from_error");
  $(".overlay-loading").hide();
  $(".warranty_form_submit_jor").removeClass("btn-disabled");
});

$("body").on("click", ".close_password", function () {
  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".reset_password_success").removeClass("view-address-model");
});
$("body").on("click", ".close_login_form", function () {

  $(".overlay").removeClass("overlay-opens-password");
  $("body").removeClass("drawer-opens-password");
  $(".social_login_master_form").removeClass("view-address-model");
  $("#google_login").find("span").text("sign in with google");
  $("#facebook_login").find("span").text("sign in with facebook");
  $(".facebook_login_btn").removeClass("pointer-none");
  $(".google_login_btn").removeClass("pointer-none");
  window.dataLayer.push({
    'event': 'login_failure', 
       'eventAction':'failure',
       'eventLabel':'invalid credentilas', 
       'eventCategory': 'login'
  });
});


var msg = $(".errors").find("li").text();
var index = msg.indexOf("please click the link included to verify your email address");
if (index !== -1) {
  $(".errors").addClass("email_successfull");
  window.dataLayer.push({
    'event': 'registration',
    'eventAction': 'registration Success', 
    'eventLabel': 'success'
  });
}

var lognFailed = msg.indexOf('Incorrect email or password.');
if(lognFailed !== -1){
  window.dataLayer.push({ 
    'event': 'account',
    'eventAction': 'login',
    'eventLabel': 'fail',
    'errorType': 'incorrect_credentials',
    'errorFields': 'Incorrect email or password.'
  });
}

$("body").on("click", ".grid-item__link", function (e) {
  e.preventDefault();
  var redirectLink = $(this).attr("href");
  var parentDiv = $(this).closest(".grid-item.grid-product");
  var productId = $(parentDiv).attr("data-product-id");
  var productTitle = $(this).find(".grid-product__title").text();
  var selectedVar = $(parentDiv).find(".variant-input.active").attr("data-value");
  var productPrice = $(parentDiv).find(".grid-product__price--current").find("span[aria-hidden='true']").text();
  var productQty = $(parentDiv).find(".variant-input.active").attr("data-variant-qty");
  var productCollection = $(parentDiv).attr("product-collection-name");
  var productType = $(parentDiv).attr("product-type");
  var productSKU = $(parentDiv).find(".variant-input.active").attr("data-sku");
  var optionName = $(parentDiv).find(".variant__label").text();
  window.dataLayer.push({
    'event': 'select_item',
    'ecommerce': {
      'items': [{
        'item_name': productTitle, // Name or ID is required. 
        'item_id': productId,
        'item_brand': 'GLO',
        'item_category': productCollection,
        'item_category_2': '',
        'item_category_3': '',
        'item_category_4': '',
        'item_variant': selectedVar,
        'item_list_name': productType,
        'item_list_id': '',
        'index': 2,
        'quantity': productQty,
        'price': productPrice
      }]
    }
  });

  window.dataLayer.push({

    'event': 'productClick',
    'ecommerce': {
      'click': {
        'actionField': {
          'list': ''
        }, // Optional list property to match list:<value> of the productImpression. 
        'products': [
          {
            'name': productTitle,
            'id': productSKU,
            'price': productPrice,
            'brand': 'GLO',
            'strength': selectedVar,
            'format': optionName,
            'dimension': selectedVar,
          }]
      }
    },
    'eventCallback': function () {
      document.location = redirectLink
    }
  });
  window.location.href = redirectLink;
});


$("body").on("click", ".cart__checkout", function () {
  // e.preventDefault();
  var singleItem = {};
  var itemsArray = [];
  var singleItem_2 = {};
  var itemsArray_2 = [];
  if ($(this).closest(".cart__page_drawer").length > 0) {

    $(".cart__page_drawer").find('.cart__item').each(function (i, obj) {

      singleItem.item_name = $(this).attr("data-title");
      singleItem.price = $(this).attr("data-price");
      singleItem.item_category = $(this).attr("data-collection");
      singleItem.item_category_2 = '';
      singleItem.item_category_3 = '';
      singleItem.item_category_4 = '';
      singleItem.item_variant = $(this).find(".drawer_variant").text();
      singleItem.item_brand = 'GLO';
      singleItem.item_id = $(this).attr("data-id");
      singleItem.quantity = $(this).attr("data-qty");
      singleItem.item_list_name = '';
      singleItem.item_list_id = '';
      singleItem.index = '';

      itemsArray.push({ ...singleItem });

      singleItem_2.name = $(this).attr("data-title");
      singleItem_2.id =  $(this).attr("data-sku"); 
      singleItem_2.price = $(this).attr("data-price"); 
      singleItem_2.brand = 'GLO';
      singleItem_2.category = $(this).find(".drawer_variant_label").text();
      singleItem_2.strength =  $(this).find(".drawer_variant").text();
      singleItem_2.quantity = $(this).attr("data-qty");
      singleItem_2.format =  $(this).find(".drawer_variant_label").text();
      singleItem_2.dimension= $(this).find(".drawer_variant").text();
      itemsArray_2.push({ ...singleItem_2 });
    });
  }
  else {
    if ($(this).closest(".cart_page_master").length > 0) {
      $(".cart_page_master").find('.cart__item').each(function (i, obj) {
        singleItem.item_name = $(this).attr("data-title");
        singleItem.price = $(this).attr("data-price");
        singleItem.item_category = $(this).attr("data-collection");
        singleItem.item_category_2 = '';
        singleItem.item_category_3 = '';
        singleItem.item_category_4 = '';
        singleItem.item_variant = $(this).find(".drawer_variant").text();
        singleItem.item_brand = 'GLO KZ';
        singleItem.item_id = $(this).attr("data-id");
        singleItem.quantity = $(this).attr("data-qty");
        singleItem.item_list_name = '';
        singleItem.item_list_id = '';
        singleItem.index = '';
        itemsArray.push({ ...singleItem });

        singleItem_2.name = $(this).attr("data-title");
        singleItem_2.id =  $(this).attr("data-sku"); 
        singleItem_2.price = $(this).attr("data-price"); 
        singleItem_2.brand = 'GLO KZ';
        singleItem_2.category = $(this).find(".drawer_variant_label").text();
        singleItem_2.category_2 = '';
        singleItem_2.category_3 = '';
        singleItem_2.category_4 = '';
        singleItem_2.strength =  $(this).find(".drawer_variant").text();
        singleItem_2.quantity = $(this).attr("data-qty");
        singleItem_2.format =  $(this).find(".drawer_variant_label").text();
        singleItem_2.dimension= $(this).find(".drawer_variant").text();
        itemsArray_2.push({ ...singleItem_2 });
      });
    }
  }
  onCheckout(itemsArray, itemsArray_2);

});

function onCheckout(itemslist, itemslist_2) {
  window.dataLayer.push({
    'event': 'begin_checkout',
    'ecommerce': {
      'items': itemslist
    }
  });
  window.dataLayer.push({
    'event': 'checkout',
    'ecommerce': {
      'currencyCode': 'KZT',
      'checkout': {
        'actionField': { 'step': 1 },
        'products': itemslist_2
      }
    },
    'eventCallback': function () {
      // if (window.location.href.indexOf("/kk") > -1) {
      //   document.location = '/checkout?locale=kk';
      // }
      // else{
      //   document.location = '/checkout';
      // }
    }
  });
}
$("body").on("click", ".account_sign_out", function () {
  window.dataLayer.push({
    'event': 'account',
    'eventAction': 'logout',
    'eventLabel': 'success'
  });
});

$("body").on("click", ".no-customer", function(){
  window.dataLayer.push({
    'event': 'login_attempt', 
       'eventAction':'attempt',
       'eventLabel':'signin',
       'eventCategory' : 'login'
  });
});



$("body").on("click", ".js-qty__adjust_cart", function () {
  var inputVal = parseInt($(this).closest(".cart_update_button_master").find("input").val());
  var productId = $(this).closest(".cart_update_button_master").find("input").attr("data-id");
  var parentDiv = $(this).closest(".cart__item");
  var productTitle = $(parentDiv).attr("data-title");
  var price = $(parentDiv).attr("data-price");
  var collection = $(parentDiv).attr("data-collection");
  var variant = $(parentDiv).find(".drawer_variant").text();
  var sku = $(parentDiv).attr("data-sku");
  if ($(this).hasClass("js-qty__adjust--minus")) {
      inputVal = inputVal;
      window.dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
          'remove': {
            'products': [
              {
                'name': productTitle,
                'id': sku,
                'price': price,
                'brand': 'GLO',
                'strength': variant,
                'quantity': inputVal,
                'format': 'Can',
                'dimension': variant,
              }
            ]
          }
        }
      });
      window.dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
          'items': [
              {
              'item_name': productTitle, // Name or ID is required.
              'item_id': productId,
              'price': price,
              'item_brand': 'GLO',
              'item_category': collection,
              'item_category_2' : '',
              'item_category_3' : '',
              'item_category_4' : '',
              'item_variant': variant,
              'item_list_name': '',
              'item_list_id': '',
              'index': 1,
              'quantity': inputVal
            }
          ]
        }
      });
    }
  else {
    window.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [{
          'item_name': productTitle, // Name or ID is required. 
          'item_id': productId,
          'price': price,
          'item_brand': 'GLO',
          'item_category': collection,
          'item_category_2': '',
          'item_category_3': '',
          'item_category_4': '',
          'item_variant': variant,
          'item_list_name': '',
          'item_list_id': '',
          'index': 1,
          'quantity': inputVal
        }]
      }
    });
  }
});

$("body").on("click", ".cart__remove a", function(e){
  
  if($(this).hasClass("custom_remove_link")){
    var dataKeyId = '';
    e.preventDefault();
      var updates = new Array();
    var currentlink = $(this).attr("href");
    var qty = 0;
    var data = { updates: {} };
    $(".custom_remove_link ").each(function () {
      // dataKeyId = $(this).data("id");
      data.updates[$(this).data("id")] = qty;
    });
    jQuery.ajax({
      type: 'POST',
      url: theme.routes.cartUpdate,
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = "/cart"
      }
    });
  }
  else{
    var currentlink = $(this).attr("href");
    var parentDiv = $(this).closest(".cart__item");
    var productTitle = $(parentDiv).attr("data-title");
    var price = $(parentDiv).attr("data-price");
    var variant = $(parentDiv).find(".drawer_variant").text();
    var sku = $(parentDiv).attr("data-sku");
    var collection = $(parentDiv).attr("data-collection");
    var productId = $(parentDiv).attr("data-id");
    window.dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [
            {
              'name': productTitle,
              'id': sku,
              'price': price,
              'brand': 'GLO',
              'strength': variant,
              'quantity': 0,
              'format': 'Can',
              'dimension': variant,
            }
          ]
        }
      }
    });
    window.dataLayer.push({
        'event': 'remove_from_cart',
        'ecommerce': {
          'items': [
              {
              'item_name': productTitle, // Name or ID is required.
              'item_id': productId,
              'price': price,
              'item_brand': 'GLO',
              'item_category': collection,
              'item_category_2' : '',
              'item_category_3' : '',
              'item_category_4' : '',
              'item_variant': variant,
              'item_list_name': '',
              'item_list_id': '',
              'index': '',
              'quantity': 0
            }
          ]
        }
      });
    window.location.href=currentlink;
  }
});
if (window.location.href.indexOf("/kk") > -1) {
  var loginRegisterUrl = $("#login_register").attr("href");
  $("#login_register").attr("href", "/kk"+loginRegisterUrl);
  $("#russian_content").hide();
  $("#kazakh_content").show();
  $(".kazakh_content").show();
  $(".russian_content").hide();
}
else{
  $("#kazakh_content").hide();
  $("#russian_content").show();
  $(".russian_content").show();
  $(".kazakh_content").hide();
}
$("body").on("click", ".kazakh_content.header_russian", function(e){
  e.preventDefault();
  let baseUrl = window.location.href;
  var urlObj = new URL(baseUrl);
  var newURL = urlObj.href.replace(urlObj.origin, '');
  var ret = newURL.replace('/kk','');
  window.location.href = urlObj.origin+""+ret;
});
$("body").on("click", ".russian_content.header_kazakh", function(e){
  e.preventDefault();
  let baseUrl = window.location.href;
  var urlObj = new URL(baseUrl);
  var newURL = urlObj.href.replace(urlObj.origin, '');
  var ret = newURL.replace('/kk/','');
  if(ret === '/'){
    newUrl = urlObj.origin+"/kk";
  }
  else{
    newUrl = urlObj.origin+"/kk"+ret;
  }
  window.location.href = newUrl;
});
$("body").on("click", ".arrow_down_flag", function(){
  $(this).hide();
  $(".arrow_up_flag").show();
  $(".flags_master").slideDown();
});
$("body").on("click", ".arrow_up_flag", function(){
  $(this).hide();
  $(".arrow_down_flag").show();
  $(".flags_master").slideUp();
});

$("body").on("click", ".age_1", function () {
  localStorage.setItem("age-confirm", "age-confirm");
  $("body").find(".age_popup_section").removeClass("open-model");
    $("body").find(".welcome").addClass("show")
});
$("body").on("click", ".welcome__close, .welcome__button .button_kz", function () {
  $("body").find(".welcome").removeClass('show');
  $("body").removeClass("age-popup-active");
});

$("body").on("click", ".age_2", function () {
  $(".block__error-message").slideToggle();
});

$("body").on("click", ".stick_tile_btn", function(){
  $(this).hide();
  $(this).closest(".product-grid-form").find(".form-qty").show();
  $(this).closest(".product-grid-form").find(".stick_btn_atc").show();
});

$("body").on("click", ".filter_option", function () {
  $(".filter_option").removeClass("active");
  $(this).addClass("active");

  var tagText = $(this).attr("data-text");
  var collectionHandle = $(this).attr("data-collection");
  var collcetionUrlAll = '';
  var collcetionUrlSort = '';

  if(window.location.href.indexOf("/kk") > -1){
    collcetionUrlAll = '/kk-kz/collections/' + collectionHandle;
    collcetionUrlSort = '/kk-kz/collections/' + collectionHandle + '/' + tagText + '/?view=sort-by';
  }
  else{
    collcetionUrlAll ='/ru-kz/collections/' + collectionHandle;
    collcetionUrlSort = '/ru-kz/collections/' + collectionHandle + '/' + tagText + '/?view=sort-by'
  }
  if (tagText === '_all') {
    $.ajax({
      type: 'GET',
      url: collcetionUrlAll,
      async: false,
      success: function (data) {
        $(".collection_grid_master").html('');
        $(".collection_grid_master").html(data);
      }
    });
  }
  else {
    $.ajax({
      type: 'GET',
      url: collcetionUrlSort,
      async: false,
      success: function (data) {
        $(".collection_grid_master").html('');
        $(".collection_grid_master").html(data);
      }
    });
  }
});
$("body").on("click", ".plp_filter_col", function(){
  $(".plp_filter_col").removeClass("active");
  $(this).addClass("active");
  var colHandle = $(this).data("id");
  $(".single_collection_master").fadeOut();
  $(".single_collection_master[data-id='"+colHandle+"']").fadeIn();
});
$("body").on("click", ".clear_all_reset", function(){
  $(".plp_filter_col").removeClass("active");
  $(".single_collection_master").fadeIn();
  $(".plp_filter_sidebar").removeClass("active");
});
$("body").on("click", ".mobile_filter", function(){
  $(".mobile_filter").removeClass("active");
  $(this).addClass("active");
});
$("body").on("click", ".plp_mbl_button", function(){
  $(".plp_filter_sidebar").addClass("active");
});
$("body").on("click", ".show_results", function(){
  var colHandle = $(".mobile_filter.active").data("id");
  $(".single_collection_master").fadeOut();
  $(".single_collection_master[data-id='"+colHandle+"']").fadeIn();
  $(".plp_filter_sidebar").removeClass("active");
})

$("body").on("click", ".russian_content.rusian_lang, .kazakh_content.rusian_lang", function(e){
  e.preventDefault();
  let baseUrl = window.location.href;
  var urlObj = new URL(baseUrl);
  var newURL = urlObj.href.replace(urlObj.origin, '');
  var ret = newURL.replace('/kk-kz','/ru-kz');
  window.location.href = urlObj.origin+""+ret;
});
$("body").on("click", ".russian_content.kz_lang , .kazakh_content.kz_lang", function(e){
  e.preventDefault();
  let baseUrl = window.location.href;
  var urlObj = new URL(baseUrl);
  var newURL = urlObj.href.replace(urlObj.origin, '');
  var ret = newURL.replace('/ru-kz','');
  if(ret === '/'){
    newUrl = urlObj.origin+"/kk-kz";
  }
  else{
    newUrl = urlObj.origin+"/kk-kz"+ret;
  }
  window.location.href = newUrl;
});

$("body").on("click", ".trade-in-cta", function () {
  var dataId= $(this).data("id");
  if(dataId != ''){
    $(".overlay").addClass("overlay-opens");
    $("body").addClass("age-popup-active");
    $(this).addClass("trade-in-active");
    $(".trade_in_devices").addClass("view-trade_in_devices");
    }
  else{
    window.location.href= "/account/login"
    if (window.location.href.indexOf("/kk") > -1) {
      window.location.href= "/kk-kz/account/login"
    }
    else{
      window.location.href= "/ru-kz/account/login"
    }
  }
});


$("body").on("click", ".trade-in_cart", function () {
  $(".trade-in_cart").removeClass("selected_device");
  $(this).addClass("selected_device");
  var tradeCheckBox = $("#accepts_trade_in");
  if($(tradeCheckBox).checked){
    $(".trade_in_atc_final").removeClass("not_allowed");
  }
});
$("body").on("click", ".close-device svg", function(){
  $(".overlay").removeClass("overlay-opens");
  $("body").removeClass("age-popup-active");
  $(".trade-in-cta").removeClass("trade-in-active");
  $(".trade_in_devices").removeClass("view-trade_in_devices");
});

$("body").on("change",'#accepts_trade_in', function() {
  var tradeInDevice = $(".trade-in_cart.selected_device");
  if (this.checked && tradeInDevice.length > 0) {
    $(".trade_in_atc_final").removeClass("not_allowed");
  } else {
    $(".trade_in_atc_final").addClass("not_allowed");
  }
});

$("body").on("click", ".trade_in_atc_final", function(){
  var tradeInDevice = $(".trade-in_cart.selected_device");
  var oldId = $(tradeInDevice).data("id");
  var OldProductName = $(tradeInDevice).data("name");
  var parentEle = $(".trade-in-cta.trade-in-active");
  var parentDiv = $(parentEle).closest(".grid-item.grid-product");
  if(parentDiv.length > 0){
    var productId = $(parentEle).closest(".product_variants_collections").find(".selected-variant").closest(".variant-input").attr("data-id");
    var qty = $(parentEle).closest(".product-grid-form").find(".input-text").val();
    var productPrice = $(parentDiv).find(".grid-product__price--current").find(".visually-hidden").text();
    var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
    var collectionName = $(parentDiv).attr("product-collection-name");
    var productTitle = $(parentDiv).find(".grid-product__title").text();
    var sku = $(parentDiv).find(".variant-input.active").attr("data-sku");
    var optionName = $(parentDiv).find(".variant__label").text();
  }
  else{
    var parentEle = $(".trade-in-cta.trade-in-active");
    var parentDiv = $(parentEle).closest(".product-single__meta");
    var qty = $(parentDiv).closest("div[data-product-blocks]").find(".js-qty__num").val();
    var productId = $(parentDiv).find(".product_variant_picker").find(".variant-input.active").attr("data-id");
    if((typeof productId === "undefined")){
      productId = $(".product-single__variants").val();
    }
    var sku = $(parentDiv).find(".product_variant_picker").find(".variant-input.active").attr("data-sku");
    $(parentEle).find("span[data-default-text]").text("Добавление...");
    var productPrice = $(parentDiv).find(".product__price").find(".visually-hidden").text();
    var variant = $(parentDiv).find(".variant-input.active").attr("data-value");
    
    var collectionName = $(parentDiv).closest(".product-section").attr("data-collection");
    var productTitle = $(parentDiv).closest(".product-section").attr('data-product-title');
    var optionName = $(parentDiv).find(".variant__label").text();
  }
  var dataPresale = $(this).data("presale");
  addToCart(dataPresale, productId, qty, productTitle, productPrice, variant, collectionName, sku, optionName, grid_button = parentEle, oldId = oldId, OldProductName = OldProductName);
});

(function () {
  // Guard against double-initialisation (theme editor can inject scripts multiple times)
  if (window.__discoverApexToggleInit) return;
  window.__discoverApexToggleInit = true;

  /** Detect Shopify theme editor mode */
  function isDesignMode() {
    if (window.Shopify && window.Shopify.designMode) return true;
    if (document.documentElement && document.documentElement.classList.contains("shopify-design-mode")) return true;
    if (document.body && document.body.classList.contains("shopify-design-mode")) return true;
    return false;
  }

  /** Detect if current page is the Discover APEX page (storefront + theme editor preview) */
  function isDiscoverApexPage() {
    var pathname = window.location.pathname || "";
    var href = window.location.href || "";

    if (document.body && document.body.classList.contains("page-discover-apex")) return true;
    if (pathname.indexOf("/pages/discover-apex") !== -1) return true;

    try {
      var params = new URLSearchParams(window.location.search || "");
      var previewPath = params.get("previewPath") || params.get("preview_path") || "";
      if (previewPath) {
        previewPath = decodeURIComponent(previewPath);
        if (previewPath.indexOf("/pages/discover-apex") !== -1) return true;
      }
    } catch (e) {}

    if (href.indexOf("discover-apex") !== -1) return true;
    return false;
  }

  // Run ONLY on Discover APEX page
  if (!isDiscoverApexPage()) return;

  var GROUPS = ["apex", "apex-plus"];
  var DEFAULT_GROUP = "apex-plus";

  /** Normalize a group value to one of the allowed groups */
  function normalizeGroup(raw) {
    var g = (raw || "").toString().replace("#", "").trim();
    return GROUPS.indexOf(g) > -1 ? g : DEFAULT_GROUP;
  }

  /** Read the active group from the current hash */
  function currentGroup() {
    return normalizeGroup(window.location.hash || "");
  }

  /** Set the URL hash without creating a new history entry */
  function setHash(group) {
    var g = normalizeGroup(group);
    var nextHash = "#" + g;

    try {
      if (window.location.hash !== nextHash) {
        history.replaceState(null, "", window.location.pathname + window.location.search + nextHash);
      }
    } catch (e) {
      if (window.location.hash !== nextHash) window.location.hash = g;
    }
  }

  /** Quick check: element is actually measurable/visible in layout */
  function isElementVisible(el) {
    if (!el) return false;
    if (el.hidden) return false;
    if (el.offsetParent === null) return false;
    return true;
  }

  /** Read per-section group configuration markers (used by other sections like product lists) */
  function hydrateDiscoverSectionGroups() {
    var markers = document.querySelectorAll(
      "[data-discover-group-config], [data-discover-group-setting], .discover-group-config[data-discover-group]"
    );

    markers.forEach(function (cfg) {
      var group =
        (cfg.getAttribute("data-discover-group-config") ||
          cfg.getAttribute("data-discover-group-setting") ||
          cfg.getAttribute("data-discover-group") ||
          "")
          .toString()
          .trim();

      if (!group) return;

      var root = cfg.closest(".shopify-section") || cfg.closest("section") || cfg.parentElement;
      if (!root) return;

      root.setAttribute("data-discover-group", group);
      root.classList.add("discover-group-section");
    });
  }

  /** Re-init or refresh Slick sliders inside the currently-visible group */
  function ensureAndRefreshSlick(group) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    var $ = window.jQuery;
    var selector = '.discover-group-section[data-discover-group="' + group + '"]';
    var $roots = $(selector);

    var refOpts = null;
    var $ref = $(".product-grid.slick-initialized").first();
    if ($ref.length) {
      try {
        refOpts = $ref.slick("getSlick").options;
      } catch (e) {
        refOpts = null;
      }
    }

    $roots.each(function () {
      var root = this;
      if (!isElementVisible(root)) return;

      var $grids = $(root).find(".product-grid");
      if (!$grids.length) return;

      $grids.each(function () {
        var $grid = $(this);

        if (!$grid.hasClass("slick-initialized")) {
          if (refOpts) {
            try {
              $grid.slick(refOpts);
            } catch (e) {}
          }
        }

        if ($grid.hasClass("slick-initialized")) {
          try {
            $grid.slick("setPosition");
          } catch (e) {}
        }
      });
    });
  }

  /** Trigger common lazyload libraries + nudge layout-dependent calculations */
  function refreshLazyLoaders() {
    try {
      if (window.lazySizes) {
        if (window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === "function") {
          window.lazySizes.loader.checkElems();
        }
        if (window.lazySizes.autoSizer && typeof window.lazySizes.autoSizer.checkElems === "function") {
          window.lazySizes.autoSizer.checkElems();
        }
      }
    } catch (e) {}

    try {
      window.dispatchEvent(new Event("resize"));
    } catch (e) {
      try {
        var ev = document.createEvent("UIEvents");
        ev.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(ev);
      } catch (e2) {}
    }
  }

  /** Force-load <img> tags within the active group (helps when a group was hidden at first render) */
  function forceLoadGroupImages(group) {
    var g = normalizeGroup(group);

    try {
      var imgs = document.querySelectorAll('.discover-group-section[data-discover-group="' + g + '"] img');

      imgs.forEach(function (img) {
        if (!img) return;

        var src = img.getAttribute("src");
        var srcset = img.getAttribute("srcset");

        if (!img.complete || (img.naturalWidth || 0) === 0) {
          if (src) img.src = src;
          if (srcset) img.srcset = srcset;
        }
      });
    } catch (e) {}
  }

  /** Refresh media (lazyload + images + sliders) for the active group */
  function refreshGroupMedia(group) {
    var g = normalizeGroup(group);

    refreshLazyLoaders();

    try {
      var nodes = document.querySelectorAll('.discover-group-section[data-discover-group="' + g + '"]');
      nodes.forEach(function (root) {
        void root.offsetHeight;
      });
    } catch (e) {}

    forceLoadGroupImages(g);
    ensureAndRefreshSlick(g);

    setTimeout(function () {
      refreshLazyLoaders();
      forceLoadGroupImages(g);
    }, 80);
  }

  /** Sync UI state for all toggle buttons */
  function syncToggleButtons(group) {
    document.querySelectorAll("[data-discover-toggle]").forEach(function (btn) {
      var t = btn.getAttribute("data-discover-toggle");
      var active = t === group;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
      btn.setAttribute("tabindex", active ? "0" : "-1");
    });
  }

  /** Cancel any pending hide transition for an element */
  function cancelPendingHide(el) {
    if (!el) return;

    el.__discoverHideToken = (el.__discoverHideToken || 0) + 1;

    if (el.__discoverHideTimeout) {
      clearTimeout(el.__discoverHideTimeout);
      el.__discoverHideTimeout = null;
    }
  }

  /** Storefront: show element (hidden/inert + classes) */
  function showStorefront(el) {
    if (!el) return;

    cancelPendingHide(el);

    el.hidden = false;
    el.classList.remove("is-hiding");

    requestAnimationFrame(function () {
      el.classList.add("is-visible");
    });

    el.setAttribute("aria-hidden", "false");
    if ("inert" in el) el.inert = false;
  }

  /** Storefront: hide element (keeps your transition behavior) */
  function hideStorefront(el) {
    if (!el) return;

    var hideToken = (el.__discoverHideToken || 0) + 1;
    el.__discoverHideToken = hideToken;

    el.classList.remove("is-visible");
    el.classList.add("is-hiding");

    el.setAttribute("aria-hidden", "true");
    if ("inert" in el) el.inert = true;

    var done = function () {
      if (el.__discoverHideToken !== hideToken) return;
      el.hidden = true;
      el.classList.remove("is-hiding");
    };

    var dur = 0;
    try {
      dur = parseFloat(getComputedStyle(el).transitionDuration) || 0;
    } catch (e) {}

    if (!dur) {
      done();
      return;
    }

    el.addEventListener(
      "transitionend",
      function (ev) {
        if (ev && ev.target !== el) return;
        done();
      },
      { once: true }
    );

    el.__discoverHideTimeout = setTimeout(done, 320);
  }

  /** Theme editor: show element (force-remove hidden/inert + display) */
  function showEditor(el) {
    if (!el) return;

    cancelPendingHide(el);

    el.removeAttribute("hidden");
    el.hidden = false;

    el.removeAttribute("inert");
    if ("inert" in el) el.inert = false;

    if (el.style) el.style.display = "";

    el.classList.remove("is-hiding");
    el.classList.add("is-visible");
    el.setAttribute("aria-hidden", "false");
  }

  /** Theme editor: hide element (force hide to prevent overlap) */
  function hideEditor(el) {
    if (!el) return;

    cancelPendingHide(el);

    el.classList.remove("is-visible");
    el.classList.remove("is-hiding");

    el.setAttribute("aria-hidden", "true");

    el.hidden = true;
    el.setAttribute("hidden", "");

    el.setAttribute("inert", "");
    if ("inert" in el) el.inert = true;

    if (el.style) el.style.display = "none";
  }

  /** Apply visibility for all discover-group elements based on active group */
  function apply(group, opts) {
    opts = opts || {};
    var editorMode = !!opts.editorMode;
    var doRefresh = opts.doRefresh !== false;
    var g = normalizeGroup(group);

    var showFn = editorMode ? showEditor : showStorefront;
    var hideFn = editorMode ? hideEditor : hideStorefront;

    var toHide = [];

    document.querySelectorAll(".discover-group-section[data-discover-group]").forEach(function (el) {
      var belongs = el.getAttribute("data-discover-group") === g;
      el.classList.add("discover-group-section");

      if (belongs) {
        showFn(el);
      } else {
        toHide.push(el);
      }
    });

    if (!editorMode) {
      requestAnimationFrame(function () {
        toHide.forEach(hideFn);
      });
    } else {
      toHide.forEach(hideFn);
    }

    syncToggleButtons(g);

    if (doRefresh) {
      requestAnimationFrame(function () {
        refreshGroupMedia(g);
      });

      try {
        window.dispatchEvent(new CustomEvent("discover:group", { detail: { group: g } }));
      } catch (e) {}
    }
  }

  /** Apply + re-apply briefly to prevent late theme scripts from overriding visibility */
  function applyWithGuard(group, editorMode) {
    var g = normalizeGroup(group);

    // First apply does refresh
    apply(g, { editorMode: editorMode, doRefresh: true });

    // Re-apply without refresh (keeps state stable)
    setTimeout(function () {
      apply(g, { editorMode: editorMode, doRefresh: false });
    }, 0);

    setTimeout(function () {
      apply(g, { editorMode: editorMode, doRefresh: false });
    }, 60);

    // Small guard window to beat late overrides
    var start = Date.now();
    (function loop() {
      if (Date.now() - start > 450) return;
      apply(g, { editorMode: editorMode, doRefresh: false });
      setTimeout(loop, 90);
    })();
  }

  /** Boot the toggle behaviour */
  function boot() {
    hydrateDiscoverSectionGroups();

    var editorMode = isDesignMode();

    // Ensure a stable initial hash
    var g = currentGroup();
    setHash(g);
    applyWithGuard(g, editorMode);

    // Re-apply after full load (some themes initialise sliders on load)
    window.addEventListener("load", function () {
      try {
        var gg = currentGroup();
        applyWithGuard(gg, editorMode);
        refreshGroupMedia(gg);
      } catch (e) {}
    });

    // Toggle click handler
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest && e.target.closest("[data-discover-toggle]");
      if (!btn) return;

      e.preventDefault();

      var target = btn.getAttribute("data-discover-toggle");
      if (!target) return;

      setHash(target);
      applyWithGuard(target, editorMode);
    });

    // Hash navigation support
    window.addEventListener("hashchange", function () {
      var gg = currentGroup();
      applyWithGuard(gg, editorMode);
    });

    // Theme editor section lifecycle events
    if (editorMode) {
      var reapply = function () {
        try {
          hydrateDiscoverSectionGroups();
          applyWithGuard(currentGroup(), true);
        } catch (e) {}
      };

      document.addEventListener("shopify:section:load", function () {
        setTimeout(reapply, 0);
      });
      document.addEventListener("shopify:section:unload", function () {
        setTimeout(reapply, 0);
      });
      document.addEventListener("shopify:section:reorder", function () {
        setTimeout(reapply, 0);
      });
      document.addEventListener("shopify:section:select", function () {
        setTimeout(reapply, 0);
      });
      document.addEventListener("shopify:section:deselect", function () {
        setTimeout(reapply, 0);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();